export enum BuildType {
    dev = 'dev',
    prod = 'prod',
    beta = 'beta',
    demo = 'demo',
}
